import { Component, OnInit, Input } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { VenueCompleterComponent } from '../../venue-completer/venue-completer.component';
import { Router, ActivatedRoute } from '@angular/router';
import { ReportJobService } from '../../../services/report-job.service';
import { JobsOffer } from '../../../models/jobs-offer';
import { VenueService } from '../../../services/venue.service';
import { Observable } from "rxjs";
// import { IMyOptions, IMyDateModel } from 'mydatepicker';
import { environment } from '../../../../environments/environment';
import { MessageBoxDialog } from '../../message-box/message-box.component';

@Component({
  selector: 'app-report-offer',
  templateUrl: './report-offer.component.html',
  styleUrls: ['./report-offer.component.css']
})
export class ReportOfferComponent implements OnInit {
  @Input()offer_id: string;
  published_start:string;
  published_end:string;
  errorMessage: string;
  viewActive: boolean = false;
  selectedOption: string;
  venues: Observable<any[]>;

  venue_id:string;

  premiumView: boolean;
  premiumJob: number;

  currentDate = this.yesterday();

  // myDatePickerOptionsA: IMyOptions = {
  //   // other options...
  //   dateFormat: 'yyyy-mm-dd',
  // };

  jobs: [any];
  loading: boolean;
  max: number = 5;
  page: number = 1;
  total: number = 0;

  tooltipDisabled=false;
  showLegend = false;
  showLabels = true;
  explodeSlices = false;
  doughnut = false;
  arcWidth = 0.25;
  legendTitleInvite="Estados";
  colorSchemeInvite = {
    domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA', '#AAAAAA']
  };

  legendTitleApply="Estados";
  colorSchemeApply = {
    domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA', '#AAAAAA']
  };

  view: any[] = [];

  private landing = `${ environment.landing }`;

  constructor(
      private _router: Router,
      public dialog: MdDialog,
      private reportJobService: ReportJobService,
      private venueService: VenueService,
      private route: ActivatedRoute) {
        this.premiumView = true;
      }

  ngOnInit() {
    if (this.offer_id) {
      this.searchOffersById(this.offer_id);
    } else {
      this.searchOffers();
    }
  }

  gotoLanding (jobId) {
    window.open(this.landing + jobId, '_blank');
  }

  // getVenues() {
  //   this.venues = this.venueService.getVenues()
  //   // FIXME: remove duplicates and items without ID (shouldn't be needed)
  //     .map(res => res.filter(item => item.id && item.name));
  // }

  getVenueId($event){
    this.venue_id = $event;
  }

  private yesterday() {
    let currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - 1);

    return currentDate;
  }

  getOfferInput($event){
    this.offer_id = $event.id;
  }

  onDateChanged_end($end){
  }

  onDateChanged_start($start){
  }

  searchOffersById(jobid) {
      this.reportJobService.getReportJobDate(jobid)
      .subscribe(res => {
          this.total = res.pagination.total;
          this.loading = false;
          this.jobs = res.report_jobs;
        }
      );
  }

  searchOffers(page?: number, query?: string, venue?: string, active?: boolean, inactive?: boolean, expired?:boolean, deleted?: boolean, archived?:boolean, premiumJob?: boolean, start?: any, end?: any) {
      this.loading = true;
      let status = [];

      if(page == null) {
        page = 1;
      }

      let start_d = '';
      let end_d = '';
      if (start){
        start_d = start.formatted;
      }

      if (end){
        end_d = end.formatted;
      }

      // let premiumJob_d;
      // if (premiumJob){
      //   premiumJob_d = 1;
      // } else {
      //   premiumJob_d = 0;
      // }

      if (this.premiumView) {
        this.premiumJob = 1;
      } else {
        this.premiumJob = 0;
      }

      if (active) {
          status.push('1');
      }
      if (inactive) {
        status.push('-1');
        status.push('-2');
      }
      if (expired) {
          status.push('-3');
      }
      if (deleted) {
        status.push('-6');
      }
      if (archived) {
        status.push('-4');
      }

      this.reportJobService.getReportJobDate(query, venue, status, page, this.max, this.premiumJob, start_d, end_d)
      .subscribe(data => {
          this.page = page;
          this.total = data.pagination.total;
          this.loading = false;
          this.jobs = data.report_jobs;
        },
        error => {
          console.log(error);
        }
      );
  }

  changePremium() {
    if (this.premiumView) {
      this.premiumView = false;
    } else {
      this.premiumView = true;
    }
  }

  //noinspection JSMethodCanBeStatic
  remapJob(job) {
    job.status = 1;
    job.venue = job.venue.country.name;
  }

  printToCart(printSectionId: string) {
    let popup;
    const innerContents = document.getElementById(printSectionId).innerHTML;
    popup = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
    popup.document.open();
    popup.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">'
      + innerContents + '</html>');
    popup.document.close();
  }

  showInformation() {
    this.dialog.open(MessageBoxDialog, {data: {message: 'Conoce el reporte de tus ofertas básicas o premium según los estados definidos por la empresa y el estado de tus postulados. Genera filtros por ofertas activas, inactivas, Premium marcado las casillas del buscador. ', information: true, showIcon: true}});
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/reports/report-offer/report-offer.component.ts